import { Injectable } from '@angular/core';
import { PaymentComponentMap } from './payment-component-map';
import { HttpService } from '../';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentOptionsService {

  private readonly customOrder = [
    { type: 'upi_options', name: 'UPI Payment', description: 'Pay Directly From Your Bank Account', icon: 'upi.png', manual_hasOptions: true },
    { type: 'credit_card', name: 'Credit Card', description: 'Visa, Mastercard, Amex, Rupay, Diners & more', icon: 'credit-card.png', manual_hasOptions: true },
    { type: 'debit_card', name: 'Debit Card', description: 'Visa, Mastercard, Rupay, Diners & more', icon: 'credit-card.png', manual_hasOptions: true },
    { type: 'net_banking', name: 'Internet Banking', description: '40+ Banks Available', icon: 'mobile-banking.png', manual_hasOptions: true },
    { type: 'emi_options', name: 'EMI Payment', description: 'No Cost EMI available', icon: 'debt.png', manual_hasOptions: false },
    { type: 'wallets', name: 'Wallet', description: 'Gift cards, Amazon Pay & Mobikwik', icon: 'wallet.png', manual_hasOptions: true },
    { type: 'reward_points', name: 'Reward Points', description: 'Reward points payment options', icon: 'cards.png', manual_hasOptions: false },
    { type: 'belair_test_pg', name: 'Belair Test Payment', description: 'Belair test payment gateway', icon: 'lock.png', manual_hasOptions: false },
    { type: 'belair_balance', name: 'Belair Balance', description: 'Belair balance payment options', icon: 'lock.png', manual_hasOptions: false },
  ];

  constructor(private http: HttpService) { }

  transformPaymentOptions(paymentOptions: any): any[] {
    if (!paymentOptions) return [];
    return Object.entries(paymentOptions)
      .map(([key, value]: [string, any[]]) => {
        const customOrderItem = this.customOrder.find(item => item.type === key);
        const { name = 'Unknown', manual_hasOptions, description = 'No description available', icon = 'no image' } = customOrderItem || {};
        const sortedOptions = [...value].sort((a, b) => a.index - b.index);
        const component = PaymentComponentMap[key] || null;
        return {
          type: key,
          name: name,
          icon: icon,
          description: description,
          options: sortedOptions,
          hasOptions: sortedOptions.length > 0,
          manual_hasOptions,
          component
        };
      })
      .filter(item => item.manual_hasOptions)
      .sort((a, b) => {
        const indexA = this.customOrder.findIndex(item => item.type === a.type);
        const indexB = this.customOrder.findIndex(item => item.type === b.type);
        return indexA - indexB;
      });
  }
}
